module.exports = __webpack_public_path__ + "img/scene_romance_big@2x.3fd88576.png";